/**
 * Classe que gerencia o Grid na tela de Mapa de HOS
 *
 * @author: Adalto Junior DATE: 22/05/2013
 *
 */

import Highcharts from 'highcharts/highstock';

Greenmile.HoursOfService = Greenmile.HoursOfService || {};

Greenmile.HoursOfService.LogBookChart = function (selector, hosCollection, screen) {

    this.highChart = null;
    let driversMenuEl = null;
    let eventsByDriver = [];
    const eventsByDriverSelecteds = [];
    const arrayCategories = [];
    const colors = [
        '#00b448',
        '#000eb4',
        '#e7d92e',
        '#b92ee7',
        '#e72e2e',
        '#e7592e'
    ];
    const elementHtmlChart = document.querySelector(selector);
    const menuSelectedClass = 'routeDetailChar__menu--selected';

    const toggleClassListMenuSelected = element => element.classList.toggle(menuSelectedClass);

    const removeClassListMenuSelected = element => element.classList.remove(menuSelectedClass);

    const serializeCategoriesToXaxies = () => {

        try {
            const hosModelLength = hosCollection.size();

            for (let i = 0; i < hosModelLength; i++) {
                const model = hosCollection.at(i);
                const events = model.get("events");

                events.forEach( event => {
                    const date = Monet.Format.DateTime.parse(event.eventTime);
                    const timeEventInMilis = date.getTime();

                    arrayCategories.push(timeEventInMilis);
                });
            }

            arrayCategories.sort();

        } catch (error) {
            new Monet.Exception.ReturnError(this, "Collection not provided as parameter to the instance.")
                .console();
        }

    };

    const turnOffAllDrivers = () => {
        eventsByDriver.length = 0;
        eventsByDriverSelecteds.length = 0;
    };

    const serializeDriversEvents = ({ selectAllDriverByDefault = false }) => {

        try {
            eventsByDriver.length = 0;
            eventsByDriverSelecteds.length = 0;
            const hosModelLength = hosCollection.size();

            for (let i = 0; i < hosModelLength; i++) {
                const model = hosCollection.at(i);
                const events = model.get('events');
                const driverName = model?.attributes?.driver?.name;

                const driverEventsObject = {
                    driverName,
                    events,
                    color: colors[i]
                };

                selectAllDriverByDefault && eventsByDriverSelecteds.push(driverEventsObject);
                eventsByDriver.push(driverEventsObject);
            }

        } catch (error) {
            new Monet.Exception
                .ReturnError(
                    this,
                    'Collection not provided as parameter to the instance in serializeDriversEvents fnc.'
                )
                .console();
        }
    };

    const getDriverEventsIndex = driverWithEventsObject => {
        const eventIndex = eventsByDriverSelecteds.findIndex(driverWithEvents =>
            JSON.stringify(driverWithEvents) === JSON.stringify(driverWithEventsObject)
        );

        return eventIndex;
    };

    const selectAllDriversButton = () => {
        if (hosCollection.size() === eventsByDriverSelecteds.length) {
            const allDriversButton = document.querySelector(
                `${selector} .routeDetailChar__menu-all-drivers`
            );

            allDriversButton && toggleClassListMenuSelected(allDriversButton);
        }
    };

    const addEventsDriver = driverWithEventsObject => {
        const eventIndex = getDriverEventsIndex(driverWithEventsObject);

        if (eventIndex === -1) {
            eventsByDriverSelecteds.push(driverWithEventsObject);
            eventsByDriver = [...eventsByDriverSelecteds];

            selectAllDriversButton();
        }
    };

    const removeEventsDriver = driverWithEventsObject => {
        const eventIndex = getDriverEventsIndex(driverWithEventsObject);

        if (eventIndex !== -1) {
            eventsByDriverSelecteds.splice(eventIndex, 1);
            eventsByDriver = [...eventsByDriverSelecteds];
        }
    };

    const formatArrayOfSeries = function () {

        let error = null;

        try {

            let increment = 0;
            let timeBefore = 0;
            let lastOnDuty = null;
            let arrayData = [];
            const utils = Greenmile.HoursOfService.Utils;
            const arrayOfSeries = {
              data: [],
              categories: []
            };

            const eventOnClick = (latitude, longitude, accuracyMeters) => {

                if (latitude && longitude) {

                    const mapEvents = new Greenmile.HoursOfService.MapEvents();
                    const bounds = {
                        latitude: latitude,
                        longitude: longitude,
                        accuracyMeters: accuracyMeters
                    };

                    mapEvents.showMarkerSelected(bounds, screen);

                } else {
                    Monet.Toast.inlineToast(Monet.Toast.typeToast().info, Monet.I18n.getResourcesByKey("HOSMaps.message.noLatLongToEvent"), 2000);

                }

            };

            const addPoint = function ({
                options,
                dataForShowOnTooltip
            }) {

                const point = {
                    name: options.name,
                    y: options.y,
                    x: options.x,
                    marker: {
                        latitude: options.latitude,
                        longitude: options.longitude,
                        accuracyMeters: options.accuracyMeters
                    }
                };

                if (dataForShowOnTooltip) {
                    point.events = {
                        click: function () {
                            const marker = this.marker;
                            eventOnClick(marker.latitude, marker.longitude, marker.accuracyMeters);
                        },
                        showOnTooltip: function () {
                            return dataForShowOnTooltip;
                        }
                    };
                } else {
                    point.marker = {
                        enabled: false
                    };
                }

                return point;
            };

            const contentToTooltip = function ({
                eventTime,
                diffToEventBefore,
                resource,
                driverName,
                color
            }) {
                let diffTimeToEvents = "";

                if (diffToEventBefore) {
                    const formatter = new Monet.Format.TIME_LENGTH(diffToEventBefore);

                    diffTimeToEvents += Monet.I18n.getResourcesByKey(resource);
                    diffTimeToEvents += ` ${
                        formatter.convertMillisecondsToHoursAndMinutes().getValue()
                    }`;
                }

                const dateResource = Monet.I18n.getResourcesByKey("LogBook.chart.dateEvent");
                const dateEvent = `${dateResource} ${Monet.Format.DateTime.formatToLocale(eventTime)}`;

                const driverNameElement = driverName ? `
                    <div class='driver-name'>
                        <span style='background-color: ${color};'></span>
                        <span>${String(driverName).toUpperCase()}</span>
                    </div>` : '';
                const dateEventElement = `<div>${dateEvent}</div>`;
                const diffTimeToEventsElement = `<div>${diffTimeToEvents}</div>`;

                return `
                    <div id="hos-tooltip-row">
                        ${driverNameElement}
                        <div>
                            ${dateEventElement}
                            ${diffTimeToEventsElement}
                        </div>
                    </div>
                `;

            };

            const prepareToShowAllDrivers = ({
                events,
                driverName,
                color
            }) => {
                let content = "";
                const hosEventsLength = events.length;

                for (let j = 0; j < hosEventsLength; j++) {

                    let options = null;
                    let diffTime = undefined;
                    let resource = undefined;

                    const event = events[j];
                    const eventType = event.eventType;
                    const nextEvent = events[j + 1];
                    const eventBefore = events[j - 1];
                    const position = utils.positionByType(eventType);
                    const latitude = event.latitude;
                    const longitude = event.longitude;
                    const radius = event.accuracyMeters;
                    const date = Monet.Format.DateTime.parse(event.eventTime);
                    const isPreviousEventOnSameMoment = eventBefore && eventBefore.eventTime === event.eventTime;
                    const isNextEventOnSameMoment = nextEvent && nextEvent.eventTime === event.eventTime;

                    const isStart = eventType.indexOf("START") !== -1;
                    const isEnd = eventType.indexOf("END") !== -1;
                    const isOnDuty = eventType.indexOf("ON") !== -1;
                    const isOffDuty = eventType.indexOf("OFF") !== -1;
                    const isGreatherThanZero = increment > 0;

                    const timeEventInMilis = date.getTime();

                    const categorieXaxiesIndex = arrayCategories.indexOf(timeEventInMilis);

                    if (isOnDuty && isGreatherThanZero) {

                        options = {
                            name: timeEventInMilis,
                            x: categorieXaxiesIndex,
                            y: 1
                        };

                        arrayData.push(addPoint({ options }));
                    }

                    //armazena o on duty numa variavel
                    if (isOnDuty) {
                        lastOnDuty = event;
                    }

                    if ((isStart || isOffDuty) && isGreatherThanZero && !isPreviousEventOnSameMoment) {

                        options = {
                            name: timeEventInMilis,
                            x: categorieXaxiesIndex,
                            y: 6
                        };

                        arrayData.push(addPoint({ options }));

                    }

                    if (isStart || (isOnDuty && increment === 0)) {

                        content = contentToTooltip({
                            eventTime: timeEventInMilis,
                            driverName,
                            color
                        });

                    } else if ((isEnd || isOffDuty || isOnDuty) && isGreatherThanZero) {
                        if (isEnd) {

                            timeBefore = Monet.Format.DateTime.parse(eventBefore.eventTime).getTime();

                            diffTime = timeEventInMilis - timeBefore;

                            resource = "LogBook.chart.durationEvent";

                        } else if (isOffDuty) {

                            if (lastOnDuty !== null) {

                                timeBefore = Monet.Format.DateTime.parse(lastOnDuty.eventTime).getTime();

                                diffTime = timeEventInMilis - timeBefore;

                            }

                            resource = "LogBook.chart.durationJourney";

                        }

                        content = contentToTooltip({
                            eventTime: timeEventInMilis,
                            diffToEventBefore: diffTime,
                            resource,
                            driverName,
                            color
                        });

                    } else if (isOffDuty && j === 0) {


                        if (lastOnDuty === null) {

                            timeBefore = Monet.Format.DateTime.parse(timeEventInMilis).getTime();

                            diffTime = timeEventInMilis - timeBefore;

                        }

                        resource = "LogBook.chart.durationJourney";

                        content = contentToTooltip({
                            eventTime: timeEventInMilis,
                            diffToEventBefore: diffTime,
                            resource,
                            driverName,
                            color
                        });


                    }

                    options = {
                        name: timeEventInMilis,
                        x: categorieXaxiesIndex,
                        y: position,
                        latitude: latitude,
                        longitude: longitude,
                        accuracyMeters: radius
                    };

                    arrayData.push(addPoint({
                        options,
                        dataForShowOnTooltip: content
                    }));

                    if (isEnd && (hosEventsLength - 1 !== j) && !isNextEventOnSameMoment) {

                        options = {
                            name: timeEventInMilis,
                            x: categorieXaxiesIndex,
                            y: 6
                        };

                        arrayData.push(addPoint({ options }));

                    }

                    increment++;

                }

                increment = 0;
            };


            eventsByDriver.forEach((item) => {
                const { events, driverName, color } = item;

                prepareToShowAllDrivers({
                    events,
                    driverName,
                    color
                });

                arrayOfSeries.data.push({ data: arrayData, color });
                arrayData = [];
            });

            arrayOfSeries.categories = arrayCategories;

            return arrayOfSeries;

        } catch (e) {
            error = new Monet.Exception.ReturnError(this,
                "Parametters is undefined on format and draw markers");
            error.console();
        }

    };

    this.drawChart = function () {

        var error = null;

        try {

            var arrayOfSeries,
                width         = 0,
                diffWidth     = 30,
                i18n          = Monet.I18n,
                titleFormated = i18n.getResourcesByKey("LogBook.chart.title"),
                eventOffDutty = i18n.getResourcesByKey("LogBook.chart.yAxes.offDuty"),
                eventBreak    = i18n.getResourcesByKey("LogBook.chart.yAxes.break"),
                eventLunch    = i18n.getResourcesByKey("LogBook.chart.yAxes.lunch"),
                eventWait     = i18n.getResourcesByKey("LogBook.chart.yAxes.wait"),
                eventDriver   = i18n.getResourcesByKey("LogBook.chart.yAxes.driver"),
                eventOnDutty  = i18n.getResourcesByKey("LogBook.chart.yAxes.onDuty");

            arrayOfSeries = formatArrayOfSeries();
            const categoriesXAxis = arrayOfSeries?.categories;

            var heigth = this.getHeightParentElement();

            if (elementHtmlChart && categoriesXAxis?.length < 500) {
                const getEventsInTheSamePoint = ({
                    pointX,
                    pointY
                }) => {
                    let eventsTooltips = '';

                    arrayOfSeries.data.forEach(dataOfSeries => {
                        dataOfSeries.data.forEach(dataOfEvents => {
                            if (dataOfEvents.y === pointY &&
                                dataOfEvents.x === pointX
                            ) {
                                eventsTooltips += dataOfEvents.events.showOnTooltip();
                            }
                        });
                    });

                    return eventsTooltips;
                }

                new Highcharts.Chart({
                    chart: {
                        type: 'line',
                        renderTo: elementHtmlChart,
                        reflow: true,
                        events: {
                            load: function () {
                                const adjustTheChartSize = () => {
                                    width = $(elementHtmlChart).width() - diffWidth;

                                    if (!isNaN(width)) {
                                        this.setSize(width, heigth, true);
                                    }
                                };

                                const checkToRenderMenuDriverOrJustAppend = () => {
                                    if(!driversMenuEl) {
                                        renderMenuByDriverName();
                                    } else {
                                        elementHtmlChart && elementHtmlChart.appendChild(driversMenuEl);
                                    }
                                };

                                adjustTheChartSize();
                                checkToRenderMenuDriverOrJustAppend();
                            }
                        }
                    },
                    credits: {
                        enabled: false
                    },
                    title: {
                        text: titleFormated
                    },
                    tooltip: {
                        useHTML: true,
                        borderColor: '#9C9C9C',
                        formatter: function () {
                            const { point: { x, y } } = this;
                            let content = "";

                            if (this?.point?.events && this?.point?.events?.showOnTooltip) {
                                content = getEventsInTheSamePoint({
                                    pointX: x,
                                    pointY: y
                                });

                                return content;
                            }

                            return false;
                        }

                    },
                    xAxis: {
                        type: 'datetime',
                        dateTimeLabelFormats: {
                            millisecond: '%H:%M:%S',
                            month: '%e. %b',
                            year: '%b'
                        },
                        labels: {
                            formatter: function () {
                                return Monet.Format.DateTime.formatToLocale(this.value);
                            },
                            rotation: -40,
                            align: 'right',
                            style: {
                                fontSize: '10px'
                            }
                        },
                        categories: categoriesXAxis

                    },
                    yAxis: {
                        title: {
                            text: ''
                        },
                        labels: {
                            step: 1,
                            formatter: function () {

                                var formattedValue = "";

                                switch (this.value) {
                                    case 1:
                                        formattedValue = eventOffDutty;
                                        break;
                                    case 2:
                                        formattedValue = eventBreak;
                                        break;
                                    case 3:
                                        formattedValue = eventLunch;
                                        break;
                                    case 4:
                                        formattedValue = eventWait;
                                        break;
                                    case 5:
                                        formattedValue = eventDriver;
                                        break;
                                    case 6:
                                        formattedValue = eventOnDutty;
                                        break;
                                    default:
                                        formattedValue = "";
                                }

                                return formattedValue;
                            }
                        },
                        showEmpty: false,
                        tickInterval: 1,
                        min: 0,
                        max: 7
                    },
                    plotOptions: {
                        line: {
                            cursor: "pointer",
                            states: {
                                hover: {
                                    enabled: false
                                }
                            },
                            showInLegend: false,
                            findNearestPointBy: 'xy',
                            stickyTracking: false,
                            marker: {
                                enabled: true
                            }
                        }
                    },
                    series: arrayOfSeries.data

                });

            } else if(elementHtmlChart){

                this._renderMessageTooManyData(elementHtmlChart);

            } else {

                error = new Monet.Exception.ReturnError(this,
                    "Selector html is null");
                error.console();

            }


        } catch (e) {

            error = new Monet.Exception.ReturnError(this,
                "Error on send form hos maps.");
            error.console();

        }
    };

    this._renderMessageTooManyData = (chartElContainer) => {
        chartElContainer.hasChildNodes()
            && chartElContainer.removeChild(chartElContainer.childNodes[0]);

        const manyDataMessageEl = document.createElement('div');
        manyDataMessageEl.className = 'chart__many-data-message';
        manyDataMessageEl.innerHTML = `<i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
                                        ${Monet.I18n.getResourcesByKey("LogBook.chart.tooManyData.label")}`;

        chartElContainer.appendChild(manyDataMessageEl);
    };

    this.getHeightParentElement = function () {

        var error                 = null,
            parentNodeChartHeight = 0,
            height                = 0,
            diffHeight            = 50;

        try {

            if (elementHtmlChart !== null) {

                parentNodeChartHeight = elementHtmlChart.parentNode.style.height;

                parentNodeChartHeight = parentNodeChartHeight.replace('px', '');

                height = parseInt(parentNodeChartHeight, 10);

                height -= diffHeight;

            }

            return height;

        } catch (e) {

            error = new Monet.Exception.ReturnError(this,
                "Error on send form hos maps.");
            error.console();

        }
    };

    const renderMenuByDriverName = () => {
        const menuDiv = document.createElement('div');
        menuDiv.className = 'routeDetailChar__menu-drivers';

        const setAllDriversMenu = () => {
            const allDriversDiv = document.createElement('div');
            allDriversDiv.className = 'routeDetailChar__menu-all-drivers ';
            allDriversDiv.textContent = Monet.I18n.getResourcesByKey("LogBook.chart.menu.allDrivers.buttonLabel");
            menuDiv.appendChild(allDriversDiv);

            allDriversDiv.addEventListener('click', event => {
                const menu = event.target;
                const classIsExist = toggleClassListMenuSelected(menu);
                const allDriversMenu = document.querySelectorAll(selector + ' .routeDetailChar__menu-driver');

                if(classIsExist) {
                    allDriversMenu.forEach(driverMenu => {
                        removeClassListMenuSelected(driverMenu);
                        toggleClassListMenuSelected(driverMenu);
                    });

                    serializeDriversEvents({
                        selectAllDriverByDefault: true
                    });
                } else {
                    allDriversMenu.forEach(driverMenu => {
                        removeClassListMenuSelected(driverMenu);
                    });

                    turnOffAllDrivers();
                }

                this.drawChart();
            });
        };

        const setDriversNameMenu = (models) => {
            let hasDefaultDriver = false;

            models.forEach((model, index) => {
                const driverName = model?.attributes?.driver?.name;
                const driverEvents = model?.attributes?.events;

                if (driverName) {
                    const setDefaultDriversAsSelected = (driverEventsWithColor, driverNameDiv) => {
                        const driverType = model?.attributes?.driver?.driverType;
                        if(driverType && driverType === "DEFAULT") {
                            hasDefaultDriver = true;
                            addEventsDriver(driverEventsWithColor);
                            toggleClassListMenuSelected(driverNameDiv);
                        }
                    };

                    const driverNameDiv = document.createElement('div');
                    driverNameDiv.className = 'routeDetailChar__menu-driver ';
                    driverNameDiv.innerHTML = `
                        <span
                            style="background-color: ${colors[index]}"
                            class="routeDetailChar__menu-driver-dot-color">
                        </span>
                        <div class="routeDetailChar__menu-driver-name">
                            ${driverName}
                        </div>
                    `;

                    const driverEventsWithColor = {
                        driverName,
                        events: driverEvents,
                        color: colors[index]
                    };

                    driverNameDiv.addEventListener('click', event => {
                        const menu = event.currentTarget;
                        const classIsExist = toggleClassListMenuSelected(menu);
                        const allDriversMenu = menu.parentNode.firstChild;

                        if(classIsExist) {
                            addEventsDriver(driverEventsWithColor);
                        } else {
                            removeEventsDriver(driverEventsWithColor);
                            removeClassListMenuSelected(allDriversMenu);
                        }

                        this.drawChart();
                    });

                    menuDiv.appendChild(driverNameDiv);
                    elementHtmlChart && elementHtmlChart.appendChild(menuDiv);
                    driversMenuEl = menuDiv;

                    setDefaultDriversAsSelected(driverEventsWithColor, driverNameDiv);
                }
            });

            hasDefaultDriver && this.drawChart();
        };

        const models = hosCollection?.models;
        if(models && models.length) {
            setAllDriversMenu();
            setDriversNameMenu(models);
        }
    };

    const init = function () {
        serializeCategoriesToXaxies();
        serializeDriversEvents({
            selectAllDriverByDefault: false
        });
    };

    init();
};
